import { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import classnames from 'classnames'
import { Button } from '../../../iba-components/Button'
import { Input } from '../../../iba-components/Input'
import { showPopBanner } from '../../../iba-components/PopBanner'
import { register } from '../../api/commonV2'
import { LanguageSelect } from '../../components/LanguageSelect'
import LoadingMask from '../../components/LoadingMask'
import './register.css'
import styles from './register.module.css'

// Note: IDパスワードログインユーザーの新規登録時、ProductIAMで送信されるメールから遷移してくるページ
export const Register = () => {
    const userInfo = useSelector((state) => state.userInfo)
    const location = useLocation()
    const urlParams = Object.fromEntries(new URLSearchParams(location.search))
    const { activationId, activationToken, productId } = urlParams
    const history = useHistory()
    const { t } = useTranslation()

    const [pwd, setPwd] = useState('')
    const [repeatPwd, setRepeatPwd] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [errorMsg, setErrorMsg] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [registable, setRegistable] = useState(true)
    const [isShowTipBox, setIsShowTipBox] = useState('')
    const [showPpwwdd, setShowPpwwdd] = useState('pwd')
    const [showRepeatPpwwdd, setShowRepeatPpwwdd] = useState('pwd')

    const [tipBoxState, setTipBoxState] = useState({
        uppercaseSuccess: false,
        lowercaseSuccess: false,
        symbolSuccess: false,
        digitalSuccess: false,
        bitSuccess: false
    })
    const [phoneNumberErrorMsg, setPhoneNumberErrorMsg] = useState('')

    const TipBox = () => (
        <ul className="tip-box">
            <li
                className={classnames({
                    success: tipBoxState.uppercaseSuccess
                })}
            >
                {tipBoxState.uppercaseSuccess && <span className="icon-check-mark-outline mr-10 iconfont" />}
                {t('register.uppercase')}
            </li>
            <li
                className={classnames({
                    success: tipBoxState.lowercaseSuccess
                })}
            >
                {tipBoxState.lowercaseSuccess && <span className="icon-check-mark-outline mr-10 iconfont" />}
                {t('register.lowercase')}
            </li>
            <li className={classnames({ success: tipBoxState.symbolSuccess })}>
                {tipBoxState.symbolSuccess && <span className="icon-check-mark-outline mr-10 iconfont" />}
                {t('register.symbol')}
            </li>
            <li className={classnames({ success: tipBoxState.digitalSuccess })}>
                {tipBoxState.digitalSuccess && <span className="icon-check-mark-outline mr-10 iconfont" />}
                {t('register.digital')}
            </li>
            <li className={classnames({ success: tipBoxState.bitSuccess })}>
                {tipBoxState.bitSuccess && <span className="icon-check-mark-outline mr-10 iconfont" />}
                {t('register.8bit')}
            </li>
        </ul>
    )

    useEffect(() => {
        const updater = {
            uppercaseSuccess: false,
            lowercaseSuccess: false,
            symbolSuccess: false,
            digitalSuccess: false,
            bitSuccess: false
        }
        if (/[A-Z]/.test(pwd)) {
            updater.uppercaseSuccess = true
        }
        if (/[a-z]/.test(pwd)) {
            updater.lowercaseSuccess = true
        }
        if (/[#?!@$%^&*-]/.test(pwd)) {
            updater.symbolSuccess = true
        }
        if (/\d/.test(pwd)) {
            updater.digitalSuccess = true
        }
        if (pwd.length >= 8) {
            updater.bitSuccess = true
        }
        setTipBoxState(updater)
    }, [pwd])

    useEffect(() => {
        const validatePhoneNumber = (number) => {
            // 国際電話番号形式の正規表現
            const regex = /^\+\d{1,3}\d{4,14}$/
            return regex.test(number) ? '' : t('register.phoneNumberError')
        }
        setPhoneNumberErrorMsg(validatePhoneNumber(phoneNumber))
    }, [phoneNumber])

    useEffect(() => {
        if (repeatPwd !== pwd) {
            setErrorMsg(t('register.repeatPwdError'))
            return
        }
        setErrorMsg('')
    }, [repeatPwd, pwd, t])

    useEffect(() => {
        if (!(activationId && activationToken && productId)) {
            if (!userInfo?.token) {
                setRegistable(false)
                setErrorMsg(t('register.noEmailError'))
                showPopBanner({
                    message: t('register.noEmailError'),
                    status: 'error',
                    duration: 5000
                })
            }
        }
    }, [])

    const doSetPassword = async () => {
        setIsLoading(true)
        const params = {
            activationId,
            activationToken,
            productId,
            phoneNumber,
            newPassword: pwd
        }

        try {
            const { hasError, desc } = await register(params)
            if (hasError) {
                showPopBanner({
                    message: desc,
                    status: 'error',
                    duration: 5000
                })
                setErrorMsg(desc)
                return
            }
            history.push(`/loginiam`)
        } catch (e) {
            setErrorMsg(e.response.data.desc)
        } finally {
            setIsLoading(false)
        }
    }

    const onSubmit = (e) => {
        e.preventDefault()
        if (Object.values(tipBoxState).some((x) => !x)) {
            setIsShowTipBox(true)
            return
        }
        if (phoneNumberErrorMsg) {
            return
        }
        if (errorMsg) {
            return
        }
        doSetPassword()
    }

    return (
        <div className="a-register-middle-part register-div">
            <LanguageSelect className="language-select" />
            <div className="logo flex-center">
                <div className="a-login-logo a-pwc-theme-adapt-logon" />
            </div>
            <div className="title flex-center">{t('register.pageTitle')}</div>
            <h4 className="flex-center">{t('register.register')}</h4>
            <div className="show-pswd-btn-wrapper">
                <div style={{ fontSize: '0.75em' }}>{t('register.pwd')}</div>
                <button
                    onClick={() => {
                        if (showPpwwdd === 'pwd') {
                            setShowPpwwdd('text')
                        } else {
                            setShowPpwwdd('pwd')
                        }
                    }}
                    style={{ background: 'white', color: '#d04a02' }}
                >
                    <span className="Appkit4-icon icon-view-fill" style={{ fontSize: '0.75em' }}>
                        {showPpwwdd !== 'pwd' ? t('register.hide') : t('register.show')}
                    </span>
                </button>
            </div>
            <Input
                className={styles.input}
                type={showPpwwdd === 'pwd' ? ['p', 'a', 's', 's', 'w', 'o', 'r', 'd'].join('') : showPpwwdd}
                width={380}
                onChange={setPwd}
                onFocus={() => setIsShowTipBox(true)}
                onBlur={() => setIsShowTipBox(false)}
                hasError={Boolean(Object.values(tipBoxState).some((x) => !x) && pwd)}
                disabled={!registable}
            />
            <div className="show-pswd-btn-wrapper" style={{ marginTop: '20px' }}>
                <div style={{ fontSize: '0.75em' }}>{t('register.cPwd')}</div>
                <button
                    onClick={() => {
                        if (showRepeatPpwwdd === 'pwd') {
                            setShowRepeatPpwwdd('text')
                        } else {
                            setShowRepeatPpwwdd('pwd')
                        }
                    }}
                    style={{ background: 'white', color: '#d04a02' }}
                >
                    <span className="Appkit4-icon icon-view-fill" style={{ fontSize: '0.75em' }}>
                        {showRepeatPpwwdd !== 'pwd' ? t('register.hide') : t('register.show')}
                    </span>
                </button>
            </div>
            <Input
                type={showRepeatPpwwdd === 'pwd' ? ['p', 'a', 's', 's', 'w', 'o', 'r', 'd'].join('') : showRepeatPpwwdd}
                width={380}
                onChange={setRepeatPwd}
                hasError={Boolean(
                    (Object.values(tipBoxState).some((x) => !x) || errorMsg === t('register.repeatPwdError')) &&
                        repeatPwd
                )}
                disabled={!registable}
            />
            {errorMsg && <div className="a-register-error-info mt-10"> {errorMsg} </div>}
            <div className="show-pswd-btn-wrapper" style={{ marginTop: '20px' }}>
                <div style={{ fontSize: '0.75em' }}>
                    <div>{t('register.phoneNumber')} </div>
                    <div>{t('register.phoneNumberTip')}</div>
                </div>
            </div>
            <Input
                className={styles.input}
                width={380}
                onChange={setPhoneNumber}
                hasError={phoneNumberErrorMsg && phoneNumber}
                disabled={!registable}
                placeholder={'+819012345678 '}
            />
            {phoneNumber && phoneNumberErrorMsg && (
                <div className="a-register-error-info mt-10"> {phoneNumberErrorMsg} </div>
            )}
            <div className="btn-with-loading flex-center submitBtn">
                <Button
                    size="xl"
                    width="104px"
                    label={t('register.submit')}
                    type="submit"
                    onClick={onSubmit}
                    disabled={!registable}
                />
                {isLoading && <LoadingMask />}
            </div>
            {isShowTipBox && <TipBox />}
        </div>
    )
}
